// extracted by mini-css-extract-plugin
export var iconWrapper = "Recommended-module--icon-wrapper--567f5";
export var recommendedBadge = "Recommended-module--recommended-badge--18380";